import { CProgress } from './CProgress.js';
import { CProgressBar } from './CProgressBar.js';
import { CProgressStacked } from './CProgressStacked.js';

const CProgressPlugin = {
    install: (app) => {
        app.component(CProgress.name, CProgress);
        app.component(CProgressBar.name, CProgressBar);
        app.component(CProgressStacked.name, CProgressStacked);
    },
};

export { CProgress, CProgressBar, CProgressPlugin, CProgressStacked };
//# sourceMappingURL=index.js.map
